// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__139PP","text":"SelectPayment_text__2zje1","title":"SelectPayment_title__1cLqT","btn":"SelectPayment_btn__3gMNB"};